function getTimeZone() {
  const date = new Date().toString().match(/([-+][0-9]+)\s/)[1];
  return `${date[0]}${date[1]}${date[2]}:${date[3]}${date[4]}`;
}

export default getTimeZone;
